import React, { Component } from "react";
import { BsyUtils } from "../../utils/Utils";
import "./index.css";
import BsyMsgBubble from "../BsyMsgBubble";

class BsySearchResult extends Component {
  dalysettime = null;

  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      items: [],
      isloadSearch: true,
      autoClose: props.autoClose,
    };
    this.input = React.createRef();
  }
  RemoveValByIndex = (arr, index, length) => {
    var reg = new RegExp(index, "g");
    return arr.replace(reg, length);
  };
  inputValueEnter = (event) => {
    let key = event.target.value;
    this.setState({ isloadSearch: true, inputValue: key, items: null }, () => {
      if (this.props.async && this.props.async.url) {
        this.dalysettime && this.dalysettime.abort();
        this.dalysettime = new AbortController();
        this.creatResult([]);
        React.axios(
          this.props.async.url,
          {
            ...(this.props.async.data ? this.props.async.data : {}),
            keyword: key,
          },
          { signal: this.dalysettime.signal }
        )
          .then((res) => {
            BsyUtils.showAjaxTip(res.data, () => {
              if (this.props.async.sucess) {
                let items = this.props.async.sucess(res.data);
                let items1 = [];
                items.forEach((val) => {
                  if (val) {
                    if (val.name) {
                      if (val.name.indexOf(key) > -1) {
                        items1.push(val);
                        val.titleHtml = this.RemoveValByIndex(
                          val.name,
                          key,
                          "<i>" + key + "</i>"
                        );
                      }
                    } else if (val.appname) {
                      if (val.appname.indexOf(key) > -1) {
                        items1.push(val);
                        val.titleHtml = this.RemoveValByIndex(
                          val.appname,
                          key,
                          "<i>" + key + "</i>"
                        );
                      }
                    }
                  }
                });
                this.setState({ items: items1, isloadSearch: false });
              } else {
                this.setState({ items: res.data.list, isloadSearch: false });
              }
            });
          })
          .catch((res) => {
            // this.clearInput();
            console.error(res);
          });
      } else {
        let items = [];
        this.props.items.forEach((val) => {
          if (val) {
            if (val.name.indexOf(key) > -1) {
              items.push(val);
              val.titleHtml = this.RemoveValByIndex(
                val.name,
                key,
                "<i>" + key + "</i>"
              );
            }
          }
        });
        this.setState({ items, isloadSearch: false });
      }
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      items: nextProps.items,
      inputValue: nextProps.inputValue ? nextProps.inputValue : "",
    });
  }

  clearInput = () => {
    this.setState({ inputValue: "" }, () => {
      this.input.current.focus();
    });
  };

  onBlur = (e) => {
    const { inputValue } = this.state;
    if (inputValue) {
      return;
    }

    if (this.props.onBlur) {
      let res = this.props.onBlur(e.target.value);
      if (res === false) {
        this.msgBubble && this.msgBubble.closeAlter();
        this.msgBubble = null;
      }
    }
  };

  creatResult = (item) => {
    const { inputValue, isloadSearch, autoClose } = this.state;
    const { onCreatResult, height, dockPosition, minHeight, maxHeight } =
      this.props;

    this.msgBubble && this.msgBubble.closeAlter();
    if (!inputValue) {
      return;
    }

    BsyMsgBubble({
      anchor: this.input.current,
      isAlone: true,
      contentHTML: (s) => {
        this.msgBubble = s;
        return isloadSearch ? (
          <div className="searchLoading">{React.language("loading")}</div>
        ) : (
          onCreatResult && onCreatResult(item, s)
        );
      },
      text4Cancel: null,
      text4Ok: null,
      minWidth: this.input.current.clientWidth,
      minHeight: isloadSearch ? 40 : minHeight,
      maxHeight: maxHeight,
      width: this.input.current.clientWidth,
      height: height,
      hAdjust: -5,
      contentPadding: 0,
      edge: height - 50,
      dockPosition: dockPosition,
      // "marginTop":20,
      onClose: function (e) {
        if (!e) return !1;
        if (
          window.$(e.target).closest(".BsySearchResultInput").length > 0 ||
          window.$(e.target).closest(".bsy-msg-bubble").length > 0
        ) {
          return;
        }

        if (autoClose === false) {
          return;
        }

        return !1;
      },
    });
  };

  render() {
    const { inputValue, items } = this.state;
    const { placeholder, width } = this.props;
    return (
      <div className="BsySearchResult" style={{ width: width || "auto" }}>
        <input
          type="text"
          className="BsySearchResultInput"
          ref={this.input}
          placeholder={placeholder}
          value={inputValue}
          onBlur={this.onBlur}
          onChange={this.inputValueEnter}
        />
        {<i className="icon-bsy-reportmenu-0" />}
        {!!inputValue && (
          <i className="icon-bsy-close-small" onClick={this.clearInput} />
        )}
        <div className="searchResCont">{items && this.creatResult(items)}</div>
      </div>
    );
  }
}

export default BsySearchResult;
